/* tslint:disable */
import {
  Availability,
  WSCRequestDetail
} from '../index';

declare var Object: any;
export interface WSCToAvailabilityProfileInterface {
  "sfdcId"?: string;
  "OwnerId"?: string;
  "IsDeleted"?: boolean;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedDate"?: string;
  "CreatedById"?: string;
  "LastModifiedDate"?: string;
  "LastModifiedById"?: string;
  "SystemModstamp"?: string;
  "UserRecordAccessId"?: string;
  "Availability_Profile__c"?: number;
  "WSC_Request_Detail__c"?: number;
  "IRON_ExtID__c"?: string;
  "CreatedBy__c"?: string;
  "LastModifiedBy__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  availabilityProfile?: Availability;
  wscRequestDetail?: WSCRequestDetail;
}

export class WSCToAvailabilityProfile implements WSCToAvailabilityProfileInterface {
  "sfdcId": string;
  "OwnerId": string;
  "IsDeleted": boolean;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedDate": string;
  "CreatedById": string;
  "LastModifiedDate": string;
  "LastModifiedById": string;
  "SystemModstamp": string;
  "UserRecordAccessId": string;
  "Availability_Profile__c": number;
  "WSC_Request_Detail__c": number;
  "IRON_ExtID__c": string;
  "CreatedBy__c": string;
  "LastModifiedBy__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  availabilityProfile: Availability;
  wscRequestDetail: WSCRequestDetail;
  constructor(data?: WSCToAvailabilityProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WSCToAvailabilityProfile`.
   */
  public static getModelName() {
    return "WSCToAvailabilityProfile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WSCToAvailabilityProfile for dynamic purposes.
  **/
  public static factory(data: WSCToAvailabilityProfileInterface): WSCToAvailabilityProfile{
    return new WSCToAvailabilityProfile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WSCToAvailabilityProfile',
      plural: 'WSCToAvailabilityProfiles',
      path: 'WSCToAvailabilityProfiles',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "SystemModstamp": {
          name: 'SystemModstamp',
          type: 'string'
        },
        "UserRecordAccessId": {
          name: 'UserRecordAccessId',
          type: 'string'
        },
        "Availability_Profile__c": {
          name: 'Availability_Profile__c',
          type: 'number'
        },
        "WSC_Request_Detail__c": {
          name: 'WSC_Request_Detail__c',
          type: 'number'
        },
        "IRON_ExtID__c": {
          name: 'IRON_ExtID__c',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        availabilityProfile: {
          name: 'availabilityProfile',
          type: 'Availability',
          model: 'Availability',
          relationType: 'belongsTo',
                  keyFrom: 'Availability_Profile__c',
          keyTo: 'id'
        },
        wscRequestDetail: {
          name: 'wscRequestDetail',
          type: 'WSCRequestDetail',
          model: 'WSCRequestDetail',
          relationType: 'belongsTo',
                  keyFrom: 'WSC_Request_Detail__c',
          keyTo: 'id'
        },
      }
    }
  }
}
